<script setup>
import { supportCss } from '@common/utils'

const emit = defineEmits()
const props = defineProps({
  value: Boolean,
  destroy: Boolean, // 组件关闭时是否自动销毁内容
  closeOnClickModal: { // 是否允许点击遮罩关闭弹窗
    type: Boolean,
    default: true
  },
  showBackDrop:{
    type:Boolean,
    default:true
  },
  wrapperStyle: {
    type: [String, Object],
    default: undefined
  }
})




const classMap = computed(() => ({
  'nio-dialog': true,
  'nio-full': true,
  'nio-backdropFilter': props.showBackDrop && supportCss('backdropFilter') // 是否支持背景高斯模糊
}))

// 关闭弹窗方法、释放到子级供使用
const closeDialog = () =>{
  console.log('---关闭弹窗---');
  emit('input', false);
} 
provide('closeDialog', closeDialog)
const popstateHandel =  ()=>{
    history.forward();
  }
watchEffect(()=>{
  if(props.value){
  // 弹窗掉起时阻止页面回退
   // history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', popstateHandel);
  }else{
    history.replaceState(null, null, window.location.href);
    window.removeEventListener('popstate',popstateHandel);
  }
})


</script>

<template>
  <nio-teleport>
    <transition>
      <div
        v-show="value"
        v-if="value || !destroy"
        :class="classMap"
        :style="wrapperStyle"
        @click="closeOnClickModal && closeDialog()"
      >
        <div class="nio-dialog-content" @click.stop>
          <slot/>
        </div>
      </div>
    </transition>
  </nio-teleport>
</template>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  @include transition;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.nio-dialog {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;

  // 用before是因为backdrop-filter和background不在同一层，background需要高一层
  &::before {
    background-color: rgba(0, 0, 0, 0.5);
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  &.nio-backdropFilter {
    backdrop-filter: blur(120px);

    &::before {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
}

.nio-dialog-content {
  margin: auto;
  transform: translate3d(0, 0, 0);
  z-index: 1;
}
</style>
